
/**
 * @file   index.js 全局配置管理
 * @author zhengchanglong<zhengchanglong@baidu.com>
 * @date   2020-05-19
 */

const INITIAL_DATA = window.INITIAL_DATA || {};

export const PAGE = {
    pcHome: '/web/home/index',
    home: '/web/home/index',
    pcRuleCenter: '/web/home/pcrule',
    ruleDetail: '/web/home/ruledetail',
    smallFortune: '/web/activity/smallfortune',
    pullUser: '/web/activity/stimulate',
    goodsDetail: '/web/landing/product',
    ugcActivity: '/web/activity/topic',
    appraisalPromote: '/web/promotion/dl',
    pullUserActivity: '/web/activity/stimulate',
    couponActivity: '/web/activity/coupon',
    appPrivacy: '/web/na/appprivacy',
    lotteryDetail: '/web/draw/detail',
    lotteryResult: '/web/draw/result',
    lotteryRecord: '/web/draw/list',
    appraiser: '/web/appraiser/info',
    appraisalHelp: '/web/appraisal/appraisalhelp',
    appraisalShare: '/web/appraisal/appraisalshare'
};

export default {
    network: {
        timeout: 30000,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'X-bdsToken': INITIAL_DATA.bdsToken
        }
    }
};
